import { Q2Game } from "../../net/proto/q2_game";
import Utility from "../../../../utility/utility";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";


const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2TableResultDetailCardsPattern extends cc.Component {

    @property(cc.Node)
    nodeRoot: cc.Node = null

    @property(cc.Label)
    labelScore: cc.Label = null

    @property(cc.Node)
    nodePokerParent: cc.Node = null

    @property(PokerTablePokerBase)
    pokerPrefab: PokerTablePokerBase = null

    protected m_pokerList: PokerTablePokerBase[] = []

    show(show: boolean, codeList?: number[], score?: number){
        this.nodeRoot.active = !!show
        if(show){
            for (let index = 0; index < codeList.length; index++) {
                const code = codeList[index];
                let poker = this.getPoker(index)
                poker.fillPoker(code)
                poker.showFace(true)
                poker.showBack(false)
                poker.show()
            }
            if(score >= 0){
                this.labelScore.string = `+${score}`
            }else{
                this.labelScore.string = `${score}`
            }
            
        }
    }

    protected hideAllPokers(){
        for (let index = 0; index < this.m_pokerList.length; index++) {
            const poker = this.m_pokerList[index];
            poker.hide()
        }
    }

    protected getPoker(index: number): PokerTablePokerBase{
        let poker = this.m_pokerList[index]
        if(!poker){
            let node = cc.instantiate(this.pokerPrefab.node)
            node.parent = this.nodePokerParent
            node.position = cc.Vec2.ZERO
            node.scale = 1
            poker = node.getComponent(PokerTablePokerBase)
            this.m_pokerList[index] = poker
        }
        return poker
    }

}
